// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Oxd6zWLCewF1zZ {
  z-index: 10;
  margin: var(--ds-space-0, 0) var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-400, 16px);
  background-color: var(--ds-surface-raised, #ffffff);
  padding: var(--ds-space-075, 6px);
  color: var(--ds-text-accent-purple, #635394);
}
.Oxd6zWLCewF1zZ:hover {
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
.Oxd6zWLCewF1zZ:active {
  background-color: var(--ds-surface-raised-pressed, #dcdfe4);
}
.Oxd6zWLCewF1zZ.Czr3NP58LQ3kJY {
  background-color: var(--ds-background-accent-purple-subtlest-hovered, #dfd8fd);
  color: var(--ds-text-accent-purple, #635394);
}
.Oxd6zWLCewF1zZ.Czr3NP58LQ3kJY:hover,
.Oxd6zWLCewF1zZ.Czr3NP58LQ3kJY:focus,
.Oxd6zWLCewF1zZ.Czr3NP58LQ3kJY:active {
  background-color: var(--ds-background-accent-purple-subtlest-hovered, #dfd8fd);
}
.Oxd6zWLCewF1zZ:hover,
.Oxd6zWLCewF1zZ:focus,
.Oxd6zWLCewF1zZ:active {
  background-color: var(--ds-background-accent-purple-subtlest, #f5f2ff);
  color: var(--ds-text-accent-purple, #635394);
}
`, ""]);
// Exports
export var mirrorCardFreeBadge = `Oxd6zWLCewF1zZ`;
var _1 = `Czr3NP58LQ3kJY`;
export { _1 as "mirrorCardFreeBadge--selected" };
export default ___CSS_LOADER_EXPORT___;
